module.exports = __webpack_public_path__ + "static/media/cloud.9a0373bc.svg";